import React, {useEffect, useRef, useState} from 'react';

type Props = {
  initialValue: string;
  onSave: (value: string) => Promise<unknown>;
  onCancel: () => unknown;
};

export function RenameListItem({initialValue, onSave, onCancel}: Props) {
  const [value, setValue] = useState<string>(initialValue);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.select();
  }, []);

  const doOnSave = (
    e: React.SyntheticEvent<HTMLFormElement> | React.MouseEvent<HTMLElement>
  ) => {
    e.preventDefault();
    setIsSaving(true);
    return onSave(value).then(
      () => setIsSaving(false),
      () => setIsSaving(false)
    );
  };

  return (
    <form className="input-group" onSubmit={doOnSave}>
      <input
        ref={inputRef}
        type="text"
        autoFocus={true}
        className="form-control"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        readOnly={isSaving}
      />
      <div className="input-group-append">
        <button
          className="btn btn-outline-secondary"
          disabled={isSaving}
          type="button"
          onClick={onCancel}
        >
          <i className="fa fa-fw fa-times" />
        </button>
        <button
          type="button"
          className="btn btn-outline-primary"
          disabled={initialValue === value || isSaving}
          onClick={doOnSave}
        >
          <i
            className={`fa fa-fw ${
              isSaving ? 'fa-circle-notch fa-spin' : 'fa-check'
            }`}
          />
        </button>
      </div>
    </form>
  );
}
